<template>
  <div v-if="showResult" class="section-container">
    <h2 class="section-title">分摊结果区域</h2>

    <!-- Discount 摘要 -->
    <div v-if="mode === 'discount' && discountSummary" class="discount-summary">
      <span>原价：{{ discountSummary.totalOriginal }} 元</span>
      <span v-if="discountSummary.thresholdDiscount > 0">满减：-{{ discountSummary.thresholdDiscount }} 元</span>
      <span v-if="discountSummary.couponDiscount > 0">券：-{{ discountSummary.couponDiscount }} 元</span>
      <span class="summary-final">应付：{{ discountSummary.finalTotal }} 元</span>
    </div>

    <div class="table-container">
      <table class="result-table">
        <thead>
          <tr>
            <th>参与人</th>
            <th v-if="mode === 'discount'">原始金额</th>
            <th v-if="mode === 'discount'">优惠分摊</th>
            <th>实付金额</th>
            <th>应付金额</th>
            <th>差额类型</th>
            <th>最终金额</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in resultList" :key="index">
            <td>{{ item.name }}</td>
            <td v-if="mode === 'discount'">{{ item.originalAmount.toFixed(2) }}</td>
            <td v-if="mode === 'discount'">{{ item.discountAllocated.toFixed(2) }}</td>
            <td>{{ item.payAmount.toFixed(2) }}</td>
            <td>{{ item.shouldPay.toFixed(2) }}</td>
            <td :class="item.type === '应退' ? 'text-green' : 'text-red'">
              {{ item.type }}
            </td>
            <td :class="item.type === '应退' ? 'text-green' : 'text-red'">
              {{ item.finalAmount.toFixed(2) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 支付建议区域 -->
    <div v-if="paymentSuggestions.length > 0" class="payment-suggestions">
      <h3 class="suggestion-title">支付建议</h3>
      <div class="suggestion-list">
        <div v-for="(suggestion, index) in paymentSuggestions" :key="index" class="suggestion-item">
          <span class="suggestion-text">{{ suggestion.from }} → {{ suggestion.to }}：<span class="suggestion-amount">{{ suggestion.amount.toFixed(2) }}元</span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generatePaymentSuggestions } from '../utils/calculator';

export default {
  name: 'ResultDisplay',
  props: {
    resultList: {
      type: Array,
      default: () => []
    },
    showResult: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'simple'
    },
    discountSummary: {
      type: Object,
      default: null
    }
  },
  computed: {
    paymentSuggestions() {
      const resultCopy = JSON.parse(JSON.stringify(this.resultList));
      return generatePaymentSuggestions(resultCopy);
    }
  }
};
</script>

<style scoped>
.table-container {
  width: 100%;
  overflow-x: auto;
  margin-top: 10px;
}

.result-table {
  width: 100%;
  min-width: 400px;
  border-collapse: collapse;
  font-size: 14px;
}

.result-table th,
.result-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: center;
  white-space: nowrap;
}

.result-table th {
  background: #f5f5f5;
  font-weight: bold;
  color: #333;
  font-size: 14px;
}

.result-table tr:hover {
  background: #f9f9f9;
}

.text-green {
  color: #42b983;
  font-weight: bold;
}

.text-red {
  color: #f44336;
  font-weight: bold;
}

.discount-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  padding: 10px;
  background: #f0f8ff;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 14px;
  color: #4a5568;
}

.summary-final {
  font-weight: 700;
  color: #667eea;
}

.payment-suggestions {
  margin-top: 15px;
  padding: 12px;
  background: #f0f8ff;
  border-radius: 6px;
  border-left: 3px solid #42b983;
}

.suggestion-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.suggestion-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.suggestion-item {
  background: white;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.suggestion-text {
  font-size: 14px;
  color: #555;
  line-height: 1.4;
}

.suggestion-amount {
  font-weight: bold;
  color: #42b983;
}

@media (max-width: 750px) {
  .table-container {
    margin-top: 8px;
  }

  .result-table {
    font-size: 12px;
    min-width: 320px;
  }

  .result-table th,
  .result-table td {
    padding: 6px 4px;
    font-size: 12px;
  }

  .discount-summary {
    font-size: 12px;
    gap: 8px;
    padding: 8px;
  }

  .payment-suggestions {
    margin-top: 12px;
    padding: 10px;
  }

  .suggestion-title {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .suggestion-text {
    font-size: 12px;
  }
}

@media (max-width: 320px) {
  .result-table {
    font-size: 11px;
    min-width: 280px;
  }

  .result-table th,
  .result-table td {
    padding: 5px 3px;
    font-size: 11px;
  }

  .payment-suggestions {
    padding: 8px;
  }

  .suggestion-title {
    font-size: 13px;
  }
}
</style>
